import { api } from "@/lib/api";

const visitorId = () => {
  let id = localStorage.getItem("fv_vid");
  if (!id) {
    id = crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(16).slice(2);
    localStorage.setItem("fv_vid", id);
  }
  return id;
};

let last = "";
let lastAt = 0;

export const track = (type, path = window.location.pathname) => {
  if (localStorage.getItem("fv_token")) return;
  const key = `${type}:${path}`;
  if (key === last && Date.now() - lastAt < 1500) return;
  last = key;
  lastAt = Date.now();
  api.post("/track", { type, path, visitor_id: visitorId() }).catch(() => {});
};
